 
import React from "react";

const BannerImage = () => {
  const bannerStyles = {
   // marginTop: "60px",
    width: "100%",
    height: "90vh",
    backgroundImage:
      "url('/image/APAC-Financial-Institutions-Embrace-AI-ML-Refinitiv-Study.avif')",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    display: "flex",
    justifyContent: "flex-start",  
    alignItems: "center", 
    color: "white",
    position: "relative",
    overflow: "hidden",
    paddingLeft: "8%",  
  };

  const contentStyles = {
    maxWidth: "600px",
    animation: "slideUp 1.5s ease-out forwards",
    opacity: 0,
  };

  const headingStyles = {
    fontSize: "32px",
    margin: 0,
    lineHeight: 1.2,
    fontWeight: "bold",
    color:"white",
    textShadow: "2px 2px 8px rgba(0,0,0,0.6)",
    letterSpacing:"0px",
  };

  const paragraphStyles = {
    fontSize: "1.3rem",
    marginTop: "1rem",
    lineHeight: 1.5,
    textShadow: "1px 1px 6px rgba(0,0,0,0.6)",
    textAlign:"justify",
  };

  return (
    <div style={bannerStyles}>
      <style>
        {`
          @keyframes slideUp {
            0% {
              transform: translateY(100px);
              opacity: 0;
            }
            100% {
              transform: translateY(0);
              opacity: 1;
            }
          }

          /* Responsive text */
          @media (max-width: 1200px) {
            .banner-heading { font-size: 3rem; }
            .banner-para { font-size: 1.2rem; }
          }
          @media (max-width: 768px) {
            .banner-heading { font-size: 2.5rem; }
            .banner-para { font-size: 1.1rem; }
          }
          @media (max-width: 480px) {
            .banner-heading { font-size: 2rem; }
            .banner-para { font-size: 1rem; }
          }
        `}
      </style>

      <div style={contentStyles}>
        <h1 className="banner-heading" style={headingStyles}>
          Powering the Future with AI & ML
        </h1>
        <p className="banner-para" style={paragraphStyles}>
          Harness the intelligence of data-driven automation and machine
          learning to transform your business operations.
        </p>
      </div>
    </div>
  );
};

export default BannerImage;
